/**
 * Boxful Fulfillment 2026 home page - multilingual engine (KO/EN/ZH/JA/RU/VI)
 * Source design: boxful_app/ (static mockup)
 */

// Global state for current language
let currentLang = 'ko';

// Multilingual Translations Dictionary
const i18nData = {
  ko: {
    topBanner: '📦 <strong>박스풀 신규 입점 프로모션:</strong> 지금 신청 시 1:1 맞춤 풀필먼트 비교진단 & 택배사 규격 무료 진단 컨설팅 지원!',
    navBenefits: '박스풀 강점',
    navGlobal: '해외진출 지원',
    navContact: '견적 문의',
    navCalculator: '택배사 최저가 계산기',
    navProposal: '공식 제안서/견적서',
    navMedia: '영상 및 미디어',
    navLogin: '기업 로그인',
    navCta: '1:1 맞춤 견적 신청',
    navBlog: '블로그',
    blogSub: 'BOXFUL BLOG',
    blogTitle: '박스풀 블로그',
    blogDesc: '풀필먼트·물류 운영 노하우와 박스풀 소식을 확인해보세요.',
    blogBack: '← 목록으로',
    blogEmpty: '등록된 블로그 글이 없습니다.',
    heroBadge: '✨ Boxful Premium Fulfillment',
    heroTitle: '월요일 물류지옥 탈출!<br>반품·양품화부터 <span class="gradient-mint">규격별 최저가 택배</span>까지',
    heroDesc: '택배사를 일방적으로 고르지 마세요. 박스 크기별로 가장 저렴한 택배사가 다릅니다!<br><strong>박스풀(Boxful)</strong>에서 국내 풀필먼트 비교견적, 일 단위 요금제, 자체 스마트 WMS 및 해외 원스톱 연계로 물류비를 대폭 절감하세요.',
    heroCta1: '📦 맞춤 비교견적 즉시받기',
    heroCta2: '🔍 택배사 최저가 계산기',
    stat1Label: '당일 출고 정확도',
    stat2Label: '물류비용 절감 효과',
    stat3Label: 'WMS·양품화·해외진출',
    charTobiRole: '스마트 WMS 매니저',
    charTobiName: '토비 (Tobi)',
    charTobiBubble: '"실시간 재고 추적과 일 단위 요금제로 쓸데없는 기본료를 없애드려요!"',
    charWhaleyRole: '글로벌 인프라 리더',
    charWhaleyName: '웨일리 (Whaley)',
    charWhaleyBubble: '"베트남·대만·홍콩 등 해외 진출 시 법인설립부터 쇼핑몰 연동까지 연결!"',
    charDaramiRole: '최저가 규격 컨설턴트',
    charDaramiName: '다람이 (Darami)',
    charDaramiBubble: '"제품 박스 사이즈에 가장 유리한 최저가 택배사를 맞춰 협의해 드립니다!"',
    benefitsSub: 'WHY BOXFUL FULFILLMENT',
    benefitsTitle: '왜 박스풀 풀필먼트인가요?',
    benefitsDesc: '자체 개발 특허 솔루션과 최첨단 인프라로 번거로운 물류 고민을 완벽하게 해결합니다.',
    benefit1Title: '일 단위 합리적 요금제',
    benefit1Desc: '사용한 만큼만 결제되는 투명한 일 단위 가격 책정 시스템으로 사용하지 않는 불필요한 기본료가 없습니다.',
    benefit2Title: '반품 & 양품화 특화',
    benefit2Desc: '특허 출원한 자체 시스템으로 번거로운 반품 검수, 재포장, 양품화 및 재입고를 단 한 번에 신속 처리합니다.',
    benefit3Title: 'AI 스마트 재고관리 WMS',
    benefit3Desc: '박스풀 자체 개발 WMS로 실시간 재고 확인, 자동 발주 알림, 수요 예측 도구를 통해 재고 결품을 방지합니다.',
    benefit4Title: '광주 1~4 최첨단 센터',
    benefit4Desc: 'CCTV 24시간 보안, 화재보험 100% 가입, 항온·항습이 완벽히 조절되는 최신식 전문 물류센터에서 안전 보관합니다.',
    calcSub: 'KEY DIFFERENTIATION #2',
    calcTitle: '택배사 일방 지정 NO! <span class="gradient-mint">규격별 최저가 택배사 맞춤 협의</span>',
    calcDesc: '택배사마다 극소/소/중/대형 박스 크기(cm) 및 무게 요율 기준이 모두 다릅니다.<br>박스풀은 고객 제품의 박스 사이즈에 가장 유리한 최저가 택배사를 유연하게 협의 및 선택해 드립니다.',
    calcBoxTitle: '📦 택배사 규격별 최저가 실시간 비교 계산기',
    calcBoxDesc: '제품 박스의 세 변의 합(가로+세로+높이)과 무게, 월 출고량을 입력하면 최적 택배사를 분석해 드립니다.',
    calcBadge: '다람이의 스마트 계산기 🐿️',
    labelWidth: '가로 (cm)',
    labelDepth: '세로 (cm)',
    labelHeight: '높이 (cm)',
    labelWeight: '무게 (kg)',
    labelVolume: '월 예상 출고량 (건)',
    btnCalc: '🔍 규격 최저가 택배사 비교 분석하기',
    globalSub: 'GLOBAL EXPANSION ONE-STOP SERVICE 🌐',
    globalTitle: '국가별 해외 진출 원스톱 연계 서비스',
    globalDesc: '진출을 희망하는 국가를 선택하세요! 현지 법인 설립부터 수출 포워딩, 성분 사전 승인, 현지 대표 쇼핑몰(Shopee, Lazada, MOMO, Amazon 등) 입점까지 원스톱으로 연결해 드립니다.',
    proposalTitle: '박스풀(Boxful) 2026 공식 제안서 & 맞춤 견적서 확인하기',
    proposalDesc: '고객사 맞춤 제안서와 입고/택배/보관/부자재 세부 단가표를 실시간으로 확인하실 수 있습니다.',
    btnProposal: '📑 Boxful 2026 공식 회사소개서 열기',
    btnQuote: '📋 Boxful 맞춤 표준견적서 열기',
    mediaSub: 'VIDEO & MEDIA INSIGHT',
    mediaTitle: '박스풀 영상 및 미디어에서 알아보기',
    mediaDesc: 'Boxful 풀필먼트의 스마트 물류 혁신과 글로벌 셀러 성공 스토리를 생생한 영상과 미디어 콘텐츠로 확인해보세요.',
    contactTitle: '📦 1:1 맞춤 비교견적 & 해외 진출 신청',
    contactDesc: '귀사의 제품 특성, 출고 박스 규격 및 희망 진출 국가에 딱 맞는 최적의 솔루션을 안내해 드립니다.',
    labelName: '담당자 성함',
    labelPhone: '연락처',
    labelCompany: '회사/상호명',
    labelEmail: '이메일',
    labelUrl: '대표 판매처 URL',
    labelVolSelect: '월 평균 출고량',
    labelCat: '판매 상품 카테고리',
    labelInterest: '관심 서비스',
    collapseHeader: '📋 더 자세한 정보를 입력하시면 빠른 맞춤 견적이 가능합니다!',
    labelSku: '예상 SKU 개수',
    labelPacking: '제품 포장방식',
    labelMsg: '희망 사항 및 추가 문의',
    btnSubmit: '🚀 1:1 맞춤 비교견적 & 원스톱 진출 신청하기',
    mobileBottomCall: '📞 전화상담',
    mobileBottomQuote: '📦 1:1 맞춤 견적 신청'
  },
  en: {
    topBanner: '📦 <strong>Boxful New Launch Offer:</strong> Apply today for 1:1 tailored fulfillment diagnosis & free box size optimization consulting!',
    navBenefits: 'Why Boxful',
    navGlobal: 'Global Logistics',
    navContact: 'Contact Us',
    navCalculator: 'Courier Calculator',
    navProposal: 'Proposal & Rates',
    navMedia: 'Video & Media',
    navLogin: 'Client Login',
    navCta: 'Request Custom Quote',
    navBlog: 'Blog',
    blogSub: 'BOXFUL BLOG',
    blogTitle: 'Boxful Blog',
    blogDesc: 'Fulfillment and logistics know-how, plus the latest news from Boxful.',
    blogBack: '← Back to list',
    blogEmpty: 'No blog posts yet.',
    heroBadge: '✨ Boxful Premium Fulfillment',
    heroTitle: 'Escape Monday Logistics Chaos!<br>From Returns to <span class="gradient-mint">Lowest-Rate Couriers by Size</span>',
    heroDesc: 'Never settle for arbitrary courier assignments. The cheapest courier changes by box dimensions!<br>Cut logistics costs up to 35% with <strong>Boxful</strong> comparative rates, daily pricing, proprietary smart WMS, and one-stop global expansion.',
    heroCta1: '📦 Get Instant Quote',
    heroCta2: '🔍 Courier Rate Calculator',
    stat1Label: 'Same-day Outbound Accuracy',
    stat2Label: 'Logistics Cost Savings',
    stat3Label: 'WMS · Returns · Global Hub',
    charTobiRole: 'Smart WMS Manager',
    charTobiName: 'Tobi',
    charTobiBubble: '"Eliminate useless base fees with real-time inventory tracking & daily pricing!"',
    charWhaleyRole: 'Global Logistics Leader',
    charWhaleyName: 'Whaley',
    charWhaleyBubble: '"Connecting entity setup, forwarding, and marketplace sync in Vietnam, Taiwan, US & more!"',
    charDaramiRole: 'Box Rate Consultant',
    charDaramiName: 'Darami',
    charDaramiBubble: '"We negotiate and assign the most profitable courier tailored to your box dimensions!"',
    benefitsSub: 'WHY BOXFUL FULFILLMENT',
    benefitsTitle: 'Why Choose Boxful Fulfillment?',
    benefitsDesc: 'Proprietary patented technology and modern warehouse infrastructure seamlessly solve complex logistics operations.',
    benefit1Title: 'Transparent Daily Pricing',
    benefit1Desc: 'Pay only for what you actually use with zero unnecessary minimum base storage fees.',
    benefit2Title: 'Returns & Re-conditioning Expert',
    benefit2Desc: 'Patented inspection, re-packaging, and re-stocking workflow resolves eCommerce returns instantly in one touch.',
    benefit3Title: 'AI Smart Inventory WMS',
    benefit3Desc: 'In-house WMS provides real-time stock sync, auto-replenishment alerts, and demand forecasting.',
    benefit4Title: 'Gwangju 1-4 Modern Hubs',
    benefit4Desc: '24/7 CCTV security, 100% insurance coverage, and automated temperature/humidity control across 4 hubs.',
    calcSub: 'KEY DIFFERENTIATION #2',
    calcTitle: 'No Fixed Courier Locks! <span class="gradient-mint">Custom Negotiated Rates by Size</span>',
    calcDesc: 'Every courier enforces different dimensional (cm) and weight (kg) tiers.<br>Boxful dynamically matches and assigns the lowest-cost courier tailored to your exact packaging size.',
    calcBoxTitle: '📦 Real-time Courier Size & Rate Comparison Calculator',
    calcBoxDesc: 'Enter box dimensions (W+D+H), weight, and monthly order volume to analyze the best courier rates instantly.',
    calcBadge: "Darami's Smart Calc 🐿️",
    labelWidth: 'Width (cm)',
    labelDepth: 'Depth (cm)',
    labelHeight: 'Height (cm)',
    labelWeight: 'Weight (kg)',
    labelVolume: 'Monthly Volume (Orders)',
    btnCalc: '🔍 Analyze Best Courier Rates Now',
    globalSub: 'GLOBAL EXPANSION ONE-STOP SERVICE 🌐',
    globalTitle: 'Country-Specific Global Expansion Hub',
    globalDesc: 'Select your target market! We bridge local entity incorporation, export forwarding, ingredient clearance, and local top marketplace onboarding (Shopee, Lazada, MOMO, Amazon, etc.).',
    proposalTitle: 'View Boxful 2026 Official Proposal & Standard Quotation',
    proposalDesc: 'Explore our complete company solution deck and standardized rate sheet in real-time.',
    btnProposal: '📑 Open Boxful 2026 Company Deck',
    btnQuote: '📋 Open Standard Quotation',
    mediaSub: 'VIDEO & MEDIA INSIGHT',
    mediaTitle: 'Discover Boxful in Video & Media',
    mediaDesc: 'Experience Boxful’s smart warehouse automation and global seller success stories through live video and media showcase.',
    contactTitle: '📦 1:1 Custom Quotation & Global Expansion Inquiry',
    contactDesc: 'Get tailored guidance on your box packaging dimensions, order volume, and international market entry.',
    labelName: 'Contact Name',
    labelPhone: 'Phone Number',
    labelCompany: 'Company / Brand Name',
    labelEmail: 'Work Email',
    labelUrl: 'Store / Website URL',
    labelVolSelect: 'Average Monthly Volume',
    labelCat: 'Product Category',
    labelInterest: 'Interested Service',
    collapseHeader: '📋 Provide extra details for faster quotation matching!',
    labelSku: 'Expected SKU Count',
    labelPacking: 'Packaging Preference',
    labelMsg: 'Requirements & Special Requests',
    btnSubmit: '🚀 Submit Inquiry for 1:1 Quote & Global Expansion',
    mobileBottomCall: '📞 Call Inquiries',
    mobileBottomQuote: '📦 1:1 Custom Quote'
  },
  vi: {
    topBanner: '📦 <strong>Ưu đãi mới từ Boxful:</strong> Đăng ký ngay để nhận tư vấn chẩn đoán fulfillment 1:1 & tối ưu kích thước hộp miễn phí!',
    navBenefits: 'Ưu thế Boxful',
    navGlobal: 'Mở rộng quốc tế',
    navContact: 'Tư vấn báo giá',
    navCalculator: 'Tính giá chuyển phát',
    navProposal: 'Hồ sơ & Báo giá',
    navMedia: 'Video & Truyền thông',
    navLogin: 'Đăng nhập WMS',
    navCta: 'Yêu cầu báo giá',
    navBlog: 'Blog',
    blogSub: 'BOXFUL BLOG',
    blogTitle: 'Blog Boxful',
    blogDesc: 'Kinh nghiệm vận hành fulfillment, logistics và tin tức mới nhất từ Boxful.',
    blogBack: '← Quay lại danh sách',
    blogEmpty: 'Chưa có bài viết nào.',
    heroBadge: '✨ Dịch vụ Fulfillment cao cấp Boxful',
    heroTitle: 'Thoát khỏi hỗn loạn vận hành Thứ Hai!<br>Từ xử lý hàng hoàn đến <span class="gradient-mint">chuyển phát giá tốt nhất theo kích cỡ</span>',
    heroDesc: 'Đừng để bị áp đặt đơn vị chuyển phát cố định. Mỗi kích cỡ hộp có đơn vị tối ưu riêng!<br>Tiết kiệm đến 35% chi phí với <strong>Boxful</strong> qua tính phí theo ngày, WMS thông minh độc quyền và mở rộng thị trường quốc tế.',
    heroCta1: '📦 Nhận báo giá ngay',
    heroCta2: '🔍 Công cụ tính giá chuyển phát',
    stat1Label: 'Độ chính xác xuất kho trong ngày',
    stat2Label: 'Hiệu quả tiết kiệm chi phí',
    stat3Label: 'WMS · Hàng hoàn · Quốc tế',
    charTobiRole: 'Quản lý Smart WMS',
    charTobiName: 'Tobi',
    charTobiBubble: '"Loại bỏ phí duy trì vô lý nhờ theo dõi tồn kho thời gian thực và tính phí theo ngày!"',
    charWhaleyRole: 'Trưởng nhóm hạ tầng quốc tế',
    charWhaleyName: 'Whaley',
    charWhaleyBubble: '"Kết nối thành lập pháp nhân, forwarding và sàn TMĐT tại Việt Nam, Đài Loan, Mỹ...!"',
    charDaramiRole: 'Chuyên gia tư vấn kích thước',
    charDaramiName: 'Darami',
    charDaramiBubble: '"Đàm phán và thiết lập đơn vị chuyển phát rẻ nhất phù hợp với từng cỡ hộp của bạn!"',
    benefitsSub: 'TẠI SAO CHỌN BOXFUL',
    benefitsTitle: 'Tại sao nên chọn Boxful Fulfillment?',
    benefitsDesc: 'Giải pháp được cấp bằng sáng chế và hạ tầng kho bãi hiện đại giải quyết triệt để mọi nỗi lo logistics.',
    benefit1Title: 'Tính phí linh hoạt theo ngày',
    benefit1Desc: 'Chỉ thanh toán cho những gì bạn thực sự sử dụng, không gánh nặng phí lưu kho tối thiểu.',
    benefit2Title: 'Chuyên xử lý hàng hoàn & tái đóng gói',
    benefit2Desc: 'Quy trình kiểm tra, làm mới và nhập lại kho độc quyền giúp giải quyết đổi trả siêu tốc.',
    benefit3Title: 'WMS dự báo tồn kho AI',
    benefit3Desc: 'Hệ thống WMS tự phát triển giúp theo dõi tồn kho theo thời gian thực và dự báo nhu cầu chính xác.',
    benefit4Title: 'Trung tâm kho Gwangju 1~4 hiện đại',
    benefit4Desc: 'An ninh camera 24/7, bảo hiểm 100%, kiểm soát nhiệt độ & độ ẩm tối tân.',
    calcSub: 'ĐẶC ĐIỂM VƯỢT TRỘI #2',
    calcTitle: 'Nói KHÔNG với áp đặt đối tác! <span class="gradient-mint">Đàm phán giá tốt nhất theo kích cỡ</span>',
    calcDesc: 'Mỗi đơn vị chuyển phát có tiêu chuẩn kích thước (cm) và trọng lượng (kg) khác nhau.<br>Boxful linh hoạt chọn đối tác tối ưu chi phí nhất cho từng loại sản phẩm.',
    calcBoxTitle: '📦 Công cụ so sánh cước chuyển phát theo kích cỡ thời gian thực',
    calcBoxDesc: 'Nhập tổng ba chiều (D+R+C), trọng lượng và sản lượng hàng tháng để phân tích đối tác tốt nhất.',
    calcBadge: 'Máy tính thông minh của Darami 🐿️',
    labelWidth: 'Chiều dài (cm)',
    labelDepth: 'Chiều rộng (cm)',
    labelHeight: 'Chiều cao (cm)',
    labelWeight: 'Trọng lượng (kg)',
    labelVolume: 'Sản lượng tháng (đơn)',
    btnCalc: '🔍 Phân tích so sánh giá chuyển phát',
    globalSub: 'DỊCH VỤ MỞ RỘNG TOÀN CẦU TRỌN GÓI 🌐',
    globalTitle: 'Cổng kết nối mở rộng thị trường quốc tế',
    globalDesc: 'Chọn quốc gia mục tiêu! Chúng tôi kết nối từ thành lập pháp nhân, vận chuyển forwarding, kiểm duyệt thành phần đến mở gian hàng TMĐT (Shopee, Lazada, TikTok Shop, Amazon...).',
    proposalTitle: 'Xem hồ sơ giới thiệu chính thức & bảng báo giá chuẩn Boxful 2026',
    proposalDesc: 'Kiểm tra hồ sơ giải pháp và bảng đơn giá chi tiết nhập kho, chuyển phát, lưu kho, vật tư.',
    btnProposal: '📑 Mở hồ sơ giới thiệu Boxful 2026',
    btnQuote: '📋 Mở bảng báo giá chuẩn Boxful',
    mediaSub: 'KHÁM PHÁ TRUYỀN THÔNG & VIDEO',
    mediaTitle: 'Khám phá Boxful qua Video & Truyền thông',
    mediaDesc: 'Tìm hiểu cải tiến logistics thông minh và câu chuyện thành công của người bán toàn cầu qua video và nội dung truyền thông sống động.',
    contactTitle: '📦 Đăng ký tư vấn báo giá 1:1 & Mở rộng quốc tế',
    contactDesc: 'Nhận giải pháp tối ưu phù hợp nhất với quy cách đóng gói và thị trường xuất khẩu mục tiêu của bạn.',
    labelName: 'Họ tên người phụ trách',
    labelPhone: 'Số điện thoại',
    labelCompany: 'Tên công ty / Thương hiệu',
    labelEmail: 'Email công việc',
    labelUrl: 'URL gian hàng / Website',
    labelVolSelect: 'Sản lượng trung bình tháng',
    labelCat: 'Ngành hàng sản phẩm',
    labelInterest: 'Dịch vụ quan tâm',
    collapseHeader: '📋 Nhập thêm thông tin chi tiết để nhận báo giá nhanh hơn!',
    labelSku: 'Số lượng SKU dự kiến',
    labelPacking: 'Quy cách đóng gói',
    labelMsg: 'Yêu cầu và câu hỏi thêm',
    btnSubmit: '🚀 Gửi yêu cầu báo giá & Mở rộng quốc tế',
    mobileBottomCall: '📞 Gọi tư vấn',
    mobileBottomQuote: '📦 Báo giá 1:1'
  },
  ru: {
    topBanner: '📦 <strong>Акция Boxful 2026:</strong> Получите индивидуальный аудит фулфилмента и консультацию по оптимизации размеров коробок!',
    navBenefits: 'Преимущества',
    navGlobal: 'Международная экспансия',
    navContact: 'Запрос сметы',
    navCalculator: 'Калькулятор тарифов',
    navProposal: 'Презентация и тарифы',
    navMedia: 'Видео и медиа',
    navLogin: 'Вход для клиентов',
    navCta: 'Запросить расчет',
    navBlog: 'блог',
    blogSub: 'BOXFUL BLOG',
    blogTitle: 'Блог Boxful',
    blogDesc: 'Опыт в фулфилменте и логистике, а также новости Boxful.',
    blogBack: '← К списку',
    blogEmpty: 'Публикаций пока нет.',
    heroBadge: '✨ Премиум фулфилмент Boxful',
    heroTitle: 'Забудьте о логистическом хаосе!<br>От работы с возвратами до <span class="gradient-mint">лучших тарифов курьеров по размерам</span>',
    heroDesc: 'Не переплачивайте за фиксированные курьерские службы. Выгодный тариф зависит от габаритов коробки!<br>Экономьте до 35% с <strong>Boxful</strong> благодаря посуточной тарификации, умной WMS и комплексному выходу на международные рынки.',
    heroCta1: '📦 Получить персональный расчет',
    heroCta2: '🔍 Калькулятор тарифов курьеров',
    stat1Label: 'Точность отгрузки день в день',
    stat2Label: 'Экономия логистических расходов',
    stat3Label: 'WMS · Возвраты · Экспорт',
    charTobiRole: 'Менеджер Smart WMS',
    charTobiName: 'Тоби (Tobi)',
    charTobiBubble: '"Исключите скрытые платежи благодаря посуточной тарификации и учету остатков в реальном времени!"',
    charWhaleyRole: 'Лидер международной инфраструктуры',
    charWhaleyName: 'Вэйли (Whaley)',
    charWhaleyBubble: '"Помощь в открытии юрлиц, форвардинге и выходе на маркетплейсы во Вьетнаме, США, Тайване и др.!"',
    charDaramiRole: 'Консультант по тарифам',
    charDaramiName: 'Дарами (Darami)',
    charDaramiBubble: '"Подбираем и согласовываем самого дешевого курьера под точные габариты вашей упаковки!"',
    benefitsSub: 'ПОЧЕМУ ВЫБИРАЮТ BOXFUL',
    benefitsTitle: 'Почему именно фулфилмент Boxful?',
    benefitsDesc: 'Запатентованные технологии и современные складские комплексы полностью снимают заботы о логистике.',
    benefit1Title: 'Посуточная тарификация',
    benefit1Desc: 'Оплата исключительно за фактически занимаемый объем без переплат за пустующее место.',
    benefit2Title: 'Обработка возвратов и переупаковка',
    benefit2Desc: 'Запатентованный процесс инспекции, восстановления товарного вида и повторного ввода в оборот.',
    benefit3Title: 'AI-прогнозирование и WMS',
    benefit3Desc: 'Собственная WMS обеспечивает мониторинг остатков в реальном времени и умное прогнозирование спроса.',
    benefit4Title: 'Современные склады Кванджу 1-4',
    benefit4Desc: 'Круглосуточное видеонаблюдение, 100% страхование и строгий климат-контроль.',
    calcSub: 'КЛЮЧЕВОЕ ОТЛИЧИЕ #2',
    calcTitle: 'Никакой привязки к одной службе! <span class="gradient-mint">Выгодный курьер под ваш размер коробки</span>',
    calcDesc: 'У каждой курьерской службы свои градации по сумме измерений (см) и весу (кг).<br>Boxful гибко подбирает службу с минимальным тарифом именно под ваш товар.',
    calcBoxTitle: '📦 Калькулятор сравнения стоимости доставки в реальном времени',
    calcBoxDesc: 'Введите сумму трех сторон (Д+Ш+В), вес и месячный объем отправлений для подбора оптимальной службы.',
    calcBadge: 'Умный калькулятор Дарами 🐿️',
    labelWidth: 'Длина (см)',
    labelDepth: 'Ширина (см)',
    labelHeight: 'Высота (см)',
    labelWeight: 'Вес (кг)',
    labelVolume: 'Объем в месяц (шт)',
    btnCalc: '🔍 Рассчитать и сравнить тарифы',
    globalSub: 'КОМПЛЕКСНАЯ МЕЖДУНАРОДНАЯ ЭКСПАНСИЯ 🌐',
    globalTitle: 'Платформа выхода на зарубежные рынки',
    globalDesc: 'Выберите целевую страну! Мы берем на себя регистрацию юрлица, экспортный форвардинг, сертификацию и интеграцию с местными маркетплейсами (Shopee, Lazada, MOMO, Amazon, Uzum).',
    proposalTitle: 'Официальная презентация Boxful 2026 и стандартная смета',
    proposalDesc: 'Ознакомьтесь с презентацией возможностей и прозрачными базовыми тарифами на приемку, упаковку и хранение.',
    btnProposal: '📑 Открыть презентацию Boxful 2026',
    btnQuote: '📋 Открыть стандартную смету',
    mediaSub: 'ВИДЕО И МЕДИА О BOXFUL',
    mediaTitle: 'Узнайте больше о Boxful в видео и медиа',
    mediaDesc: 'Оцените инновации умного фулфилмента Boxful и реальные истории успеха международных продавцов в наших видеоматериалах.',
    contactTitle: '📦 Заявка на расчет 1:1 и международный выход',
    contactDesc: 'Получите персональное коммерческое предложение под параметры ваших коробок и целевые рынки сбыта.',
    labelName: 'Контактное лицо',
    labelPhone: 'Номер телефона',
    labelCompany: 'Название компании / Бренд',
    labelEmail: 'Рабочий Email',
    labelUrl: 'Ссылка на магазин / Сайт',
    labelVolSelect: 'Средний объем в месяц',
    labelCat: 'Категория товаров',
    labelInterest: 'Интересующая услуга',
    collapseHeader: '📋 Укажите дополнительные детали для более точного расчета!',
    labelSku: 'Количество SKU',
    labelPacking: 'Тип упаковки',
    labelMsg: 'Дополнительные пожелания и вопросы',
    btnSubmit: '🚀 Отправить заявку на расчет и консультацию',
    mobileBottomCall: '📞 Позвонить',
    mobileBottomQuote: '📦 Запросить расчет'
  },
  ja: {
    topBanner: '📦 <strong>Boxful 新規出店プロモーション:</strong> 今なら1:1カスタム診断＆箱サイズ最適化コンサルティングを無料提供！',
    navBenefits: 'Boxfulの強み',
    navGlobal: '国別海外進出',
    navContact: '見積もり相談',
    navCalculator: '宅配最安値計算機',
    navProposal: '公式提案書・見積書',
    navMedia: '動画・メディア',
    navLogin: '企業ログイン',
    navCta: '1:1見積もり申請',
    navBlog: 'ブログ',
    blogSub: 'BOXFUL BLOG',
    blogTitle: 'Boxfulブログ',
    blogDesc: 'フルフィルメント・物流運営のノウハウとBoxfulの最新情報をご覧ください。',
    blogBack: '← 一覧へ戻る',
    blogEmpty: 'ブログ記事はまだありません。',
    heroBadge: '✨ Boxful Premium Fulfillment',
    heroTitle: '月曜日の出荷地獄から脱出！<br>返品・良品化から<span class="gradient-mint">規格別最安値の宅配便</span>まで',
    heroDesc: '特定の宅配会社に縛られる必要はありません。箱サイズごとに最安の宅配業者が異なります！<br><strong>Boxful（ボックスフル）</strong>の比較見積、日割り料金制、独自スマートWMS、海外ワンストップ連携で物流費を最大35%削減しましょう。',
    heroCta1: '📦 すぐに見積もりを申し込む',
    heroCta2: '🔍 宅配最安値計算機',
    stat1Label: '当日出荷精度',
    stat2Label: '物流コスト削減効果',
    stat3Label: 'WMS・良品化・海外進出',
    charTobiRole: 'スマートWMSマネージャー',
    charTobiName: 'トビ (Tobi)',
    charTobiBubble: '"リアルタイム在庫追跡と日単位の料金制で、無駄な基本料をなくします！"',
    charWhaleyRole: 'グローバルインフラリーダー',
    charWhaleyName: 'ウェイリー (Whaley)',
    charWhaleyBubble: '"ベトナム・台湾・香港などへの進出時、現地法人設立からECモール連携まで一括サポート！"',
    charDaramiRole: '最安値サイズコンサルタント',
    charDaramiName: 'ダラミ (Darami)',
    charDaramiBubble: '"商品の箱サイズに最も有利な最安値の宅配会社を交渉いたします！"',
    benefitsSub: 'WHY BOXFUL FULFILLMENT',
    benefitsTitle: 'なぜBoxfulフルフィルメントなのか？',
    benefitsDesc: '自社開発の特許ソリューションと最先端インフラで、煩雑な物流の悩みを完全に解決します。',
    benefit1Title: '日単位の合理的な料金制',
    benefit1Desc: '使った分だけお支払いいただく透明な日単位の課金体系で、使わない基本料は一切かかりません。',
    benefit2Title: '返品・良品化に特化',
    benefit2Desc: '特許出願済みの自社システムで、煩雑な返品検品・再梱包・良品化・再入庫を一度に迅速処理します。',
    benefit3Title: 'AIスマート在庫管理WMS',
    benefit3Desc: 'Boxful自社開発のWMSで、リアルタイム在庫確認・自動発注アラート・需要予測により欠品を防ぎます。',
    benefit4Title: '光州(クァンジュ)第1〜4 最先端センター',
    benefit4Desc: 'CCTV24時間セキュリティ、火災保険100%加入、恒温恒湿を完全管理する最新鋭の物流センターで安全に保管します。',
    calcSub: 'KEY DIFFERENTIATION #2',
    calcTitle: '宅配会社の一方的な指定はNO！<span class="gradient-mint">サイズ別の最安宅配会社をカスタム交渉</span>',
    calcDesc: '宅配会社ごとに極小/小/中/大型の箱サイズ(cm)と重量の料率基準がすべて異なります。<br>Boxfulはお客様の商品の箱サイズに最も有利な最安値の宅配会社を柔軟に交渉・選定します。',
    calcBoxTitle: '📦 宅配会社サイズ別 最安値リアルタイム比較計算機',
    calcBoxDesc: '商品の箱の三辺合計(幅+奥行+高さ)と重量、月間出荷量を入力すると最適な宅配会社を分析します。',
    calcBadge: 'ダラミのスマート計算機 🐿️',
    labelWidth: '幅 (cm)',
    labelDepth: '奥行 (cm)',
    labelHeight: '高さ (cm)',
    labelWeight: '重量 (kg)',
    labelVolume: '月間予想出荷量 (件)',
    btnCalc: '🔍 サイズ別 最安宅配会社を比較分析する',
    globalSub: 'GLOBAL EXPANSION ONE-STOP SERVICE 🌐',
    globalTitle: '国別 海外進出ワンストップ連携サービス',
    globalDesc: '進出をご希望の国を選択してください！現地法人設立から輸出フォワーディング、成分事前承認、現地の主要ECモール(Shopee、Lazada、MOMO、Amazonなど)への出店までワンストップでつなぎます。',
    proposalTitle: 'Boxful 2026 公式提案書＆カスタム見積書を確認する',
    proposalDesc: 'お客様専用の提案書と入庫/宅配/保管/資材の詳細単価表をリアルタイムでご確認いただけます。',
    btnProposal: '📑 Boxful 2026 公式会社案内を開く',
    btnQuote: '📋 Boxful カスタム標準見積書を開く',
    mediaSub: 'VIDEO & MEDIA INSIGHT',
    mediaTitle: 'Boxfulを動画・メディアで知る',
    mediaDesc: 'Boxfulフルフィルメントのスマート物流イノベーションとグローバルセラーのサクセスストーリーを臨場感あふれる動画でお確かめください。',
    contactTitle: '📦 1:1 カスタム見積もり＆海外進出申請',
    contactDesc: '貴社の製品特性、出荷箱サイズ、進出希望国に最適なソリューションをご案内します。',
    labelName: 'ご担当者様氏名',
    labelPhone: 'ご連絡先',
    labelCompany: '貴社名 / 屋号',
    labelEmail: 'メールアドレス',
    labelUrl: '主要販売先URL',
    labelVolSelect: '月間平均出荷量',
    labelCat: '販売商品カテゴリー',
    labelInterest: 'ご希望サービス',
    collapseHeader: '📋 より詳細な情報を入力いただくと迅速な見積もりが可能です！',
    labelSku: '予定SKU数',
    labelPacking: '製品梱包方式',
    labelMsg: 'ご要望および追加のご質問',
    btnSubmit: '🚀 1:1 カスタム見積もり＆進出相談を申し込む',
    mobileBottomCall: '📞 お電話相談',
    mobileBottomQuote: '📦 1:1 見積もり申請'
  },
  zh: {
    topBanner: '📦 <strong>Boxful 新入驻优惠：</strong>立即申请即可获得 1:1 定制履约诊断及纸箱规格免费测算咨询！',
    navBenefits: 'Boxful 优势',
    navGlobal: '出海全球物流',
    navContact: '询价咨询',
    navCalculator: '快递费用计算器',
    navProposal: '官方提案与报价',
    navMedia: '视频与媒体',
    navLogin: '企业登录',
    navCta: '申请 1:1 定制报价',
    navBlog: '博客',
    blogSub: 'BOXFUL BLOG',
    blogTitle: 'Boxful 博客',
    blogDesc: '了解履约与物流运营经验，以及 Boxful 最新动态。',
    blogBack: '← 返回列表',
    blogEmpty: '暂无博客文章。',
    heroBadge: '✨ Boxful Premium Fulfillment',
    heroTitle: '告别周一发货地狱！<br>从退货良品化到<span class="gradient-mint">按箱规最优快递议价</span>',
    heroDesc: '不要单方面指定快递！不同纸箱尺寸最便宜的快递各不相同。<br>在 <strong>Boxful</strong> 享受韩国本土比价、按天计费、自主研发智能 WMS 及一站式出海服务，大幅降低物流成本。',
    heroCta1: '📦 立即获取比价',
    heroCta2: '🔍 最优快递计算器',
    stat1Label: '当日发货准确率',
    stat2Label: '物流成本最高节省',
    stat3Label: '智能WMS·良品化·全球出海',
    charTobiRole: '智能 WMS 经理',
    charTobiName: '托比 (Tobi)',
    charTobiBubble: '"通过实时库存追踪和按天计费，帮您省去不必要的基础仓储费！"',
    charWhaleyRole: '全球基础设施负责人',
    charWhaleyName: '威利 (Whaley)',
    charWhaleyBubble: '"进军越南、台湾、香港、美国等地，从设立公司到电商平台对接全包！"',
    charDaramiRole: '最优规格顾问',
    charDaramiName: '达拉米 (Darami)',
    charDaramiBubble: '"根据您的产品包装尺寸，量身协商最具价格优势的快递公司！"',
    benefitsSub: 'WHY BOXFUL FULFILLMENT',
    benefitsTitle: '为什么选择 Boxful 履约服务？',
    benefitsDesc: '拥有自主研发专利系统与先进仓储基础设施，彻底解决繁琐的物流难题。',
    benefit1Title: '按天计费 透明公道',
    benefit1Desc: '用多少付多少，没有不合理的高额固定基础仓储费。',
    benefit2Title: '退货及良品化特化处理',
    benefit2Desc: '专利系统支持快速退货质检、重新包装、良品化再上架，一键高效处理。',
    benefit3Title: 'AI 智能库存管理 WMS',
    benefit3Desc: '自主研发系统提供实时库存同步、自动补货预警及需求预测，杜绝缺货。',
    benefit4Title: '光州 1~4 号现代化仓储中心',
    benefit4Desc: '24小时监控安防、100%火灾保险、全自动恒温恒湿调控，确保货物安全。',
    calcSub: 'KEY DIFFERENTIATION #2',
    calcTitle: '拒绝单选快递锁死！<span class="gradient-mint">按箱规协商全网最低运费</span>',
    calcDesc: '各大快递在不同尺寸与重量段的收费标准各异。<br>Boxful 根据您的产品包装精准匹配最优快递，灵活组合发货。',
    calcBoxTitle: '📦 快递规格最低价实时比价计算器',
    calcBoxDesc: '输入纸箱三边之和（长+宽+高）、重量及月发货量，即可快速分析最优快递。',
    calcBadge: '达拉米智能计算器 🐿️',
    labelWidth: '长 (cm)',
    labelDepth: '宽 (cm)',
    labelHeight: '高 (cm)',
    labelWeight: '重量 (kg)',
    labelVolume: '预计月出货量 (单)',
    btnCalc: '🔍 立即比价分析最优快递',
    globalSub: 'GLOBAL EXPANSION ONE-STOP SERVICE 🌐',
    globalTitle: '国别出海一站式对接服务',
    globalDesc: '选择您想拓展的目标市场！从设立海外当地公司、出口货代、成分预审到入驻当地主流电商（Shopee、Lazada、MOMO、Amazon等）全链路打通。',
    proposalTitle: '查看 Boxful 2026 官方提案书与定制报价单',
    proposalDesc: '在线实时查看客户定制方案及入库、快递、仓储、包装耗材详细资费表。',
    btnProposal: '📑 打开 Boxful 2026 公司介绍',
    btnQuote: '📋 打开 Boxful 标准报价单',
    mediaSub: 'VIDEO & MEDIA INSIGHT',
    mediaTitle: '视频与媒体报道',
    mediaDesc: '通过真实视频案例了解 Boxful 智能物流创新与全球跨境卖家的成功故事。',
    contactTitle: '📦 1:1 定制比价与出海咨询申请',
    contactDesc: '根据您的产品特性、纸箱规格及目标出海国家，为您提供量身定制的最优方案。',
    labelName: '联系人姓名',
    labelPhone: '联系电话',
    labelCompany: '公司 / 店铺名称',
    labelEmail: '电子邮箱',
    labelUrl: '主要销售渠道 URL',
    labelVolSelect: '月均出货量',
    labelCat: '销售商品品类',
    labelInterest: '感兴趣的服务',
    collapseHeader: '📋 填写更详细的信息可获得更精准的报价方案！',
    labelSku: '预计 SKU 数量',
    labelPacking: '产品包装方式',
    labelMsg: '具体需求与补充说明',
    btnSubmit: '🚀 提交 1:1 定制比价与出海申请',
    mobileBottomCall: '📞 电话咨询',
    mobileBottomQuote: '📦 1:1 询价申请'
  }
};

// Language Switcher Function
function switchLanguage(lang) {
  if (!i18nData[lang]) return;
  currentLang = lang;
  localStorage.setItem('boxful_lang', lang);

  const t = i18nData[lang];

  // Update text elements with data-i18n attributes
  document.querySelectorAll('[data-i18n]').forEach(el => {
    const key = el.getAttribute('data-i18n');
    if (t[key]) {
      el.innerHTML = t[key];
    }
  });

  // Update placeholders
  const placeholdered = {
    cName: { ko: '홍길동 팀장', en: 'John Doe (Manager)', zh: '张经理', vi: 'Nguyen Van A', ru: 'Иван Иванов', ja: '山田 太郎' },
    cPhone: { ko: '010-0000-0000', en: '+1 234-567-8900', zh: '+86 138-0000-0000', vi: '+84 90 123 4567', ru: '+7 900 123-45-67', ja: '090-0000-0000' },
    cCompany: { ko: '㈜고객사명', en: 'Your Brand Inc.', zh: '某某科技有限公司', vi: 'Tên Công Ty', ru: 'ООО Название Компании', ja: '株式会社サンプル' },
    cEmail: { ko: 'contact@company.com', en: 'contact@brand.com', zh: 'contact@company.cn', vi: 'contact@company.vn', ru: 'contact@company.ru', ja: 'info@company.co.jp' },
    cCategory: { ko: '화장품, 건강식품, 의류, 소형전자 등', en: 'Cosmetics, Health, Apparel, Electronics, etc.', zh: '美妆护肤、保健品、服饰鞋包、小家电等', vi: 'Mỹ phẩm, Thực phẩm chức năng, Thời trang, Điện tử...', ru: 'Косметика, БАДы, Одежда, Электроника и др.', ja: '化粧品、健康食品、アパレル、小型家電など' },
    cPacking: { ko: '택배 박스포장, 택배 봉투포장, 에어캡 추가 등', en: 'Box packaging, poly mailer, bubble wrap, etc.', zh: '纸箱打包、快递胶袋、加缠气泡膜等', vi: 'Đóng hộp, túi niêm phong, bọc chống sốc...', ru: 'Коробка, курьер-пакет, пупырчатая пленка и др.', ja: 'ダンボール包装、宅配ビニール袋、エアキャップ追加など' },
    cMessage: {
      ko: '예: 베트남 Shopee 진출을 희망합니다. 현지 법인 설립 대행 및 항공/해운 포워딩, Boxful 센터 연동 패키지 상담 부탁드립니다.',
      en: 'Example: We want to expand to Vietnam Shopee. Please provide a full package consultation including entity setup, forwarding, and Boxful warehouse integration.',
      zh: '例如：计划拓展东南亚与台湾 Shopee 市场。希望能咨询海外公司设立、跨境头程货代及 Boxful 仓配一体化出海方案。',
      vi: 'Ví dụ: Chúng tôi muốn mở rộng sang Shopee Việt Nam. Vui lòng tư vấn trọn gói thành lập pháp nhân, forwarding và tích hợp kho Boxful.',
      ru: 'Пример: Планируем выход на Shopee во Вьетнаме. Просим проконсультировать по комплексному пакету: регистрация компании, форвардинг и интеграция склада Boxful.',
      ja: '例：ベトナムShopeeへの進出を希望しています。現地法人設立代行、航空・海上フォワーディング、Boxfulセンター連携パッケージの相談をお願いします。'
    }
  };

  for (const [id, dict] of Object.entries(placeholdered)) {
    const input = document.getElementById(id);
    if (input && dict[lang]) {
      input.placeholder = dict[lang];
    }
  }

  // Update active flags & labels in header and mobile (KO -> EN -> ZH -> JA -> RU -> VI)
  const langLabels = {
    ko: '🇰🇷 한국어',
    en: '🇺🇸 English',
    zh: '🇨🇳 中文',
    ja: '🇯🇵 日本語',
    ru: '🇷🇺 Русский',
    vi: '🇻🇳 Tiếng Việt'
  };

  const currentLangLabel = document.getElementById('currentLangLabel');
  if (currentLangLabel) {
    currentLangLabel.innerText = langLabels[lang] || '🌐 Language';
  }

  // Dynamic SEO Meta Tags Update by Language
  document.documentElement.lang = lang;

  const seoMetaByLang = {
    ko: {
      title: "박스풀 풀필먼트 | 최저가 택배부터 반품, 해외 진출까지 맞춤 3PL",
      desc: "스마트 물류의 시작, Boxful 풀필먼트. 체계적인 입출고 관리와 합리적인 최저가 택배 물류를 경험해 보세요. 어떤 상품이든 가장 효율적인 맞춤형 풀필먼트 솔루션을 제안해 드립니다."
    },
    en: {
      title: "Boxful Fulfillment | Best Courier Rates by Box Size, Returns & Global 3PL",
      desc: "Escape Monday logistics chaos! Boxful Fulfillment offers optimal carrier negotiation by box dimension, patented return refurbishment, daily billing, smart WMS, and cross-border expansion."
    },
    zh: {
      title: "Boxful 履约仓配一体化 | 按箱规最优快递议价 & 退货良品化 & 韩国跨境3PL",
      desc: "告别发货难题！Boxful 韩国本土3PL履约仓配服务。按纸箱尺寸协商最低快递资费、退货快速良品化专利系统、按天透明计费、自研智能 WMS 及东南亚/全球出海一站式对接。"
    },
    ja: {
      title: "Boxful フルフィルメント | サイズ別最安宅配便 & 返品・良品化 & 韓国越境3PL",
      desc: "Boxfulスマート3PLフルフィルメント。箱サイズ別の最安宅配便提案、返品・良品化特許システム、日単位の従量課金、スマートWMSおよび東南アジア・グローバル海外進出支援。"
    },
    vi: {
      title: "Boxful Fulfillment | Tối ưu cước vận chuyển, Đổi trả & Logistics 3PL toàn cầu",
      desc: "Giải pháp Fulfillment thông minh Boxful. Đàm phán giá chuyển phát tối ưu theo kích thước thùng, xử lý hàng hoàn và tái xuất, WMS thông minh và mở rộng thị trường quốc tế."
    },
    ru: {
      title: "Boxful Фулфилмент | Оптимизация тарифов доставки, Возвраты и 3PL логистика в Корее",
      desc: "Умный фулфилмент Boxful в Корее. Подбор выгодных тарифов курьерских служб, запатентованная система обработки возвратов, гибкая тарификация и выход на глобальные рынки."
    }
  };

  if (seoMetaByLang[lang]) {
    document.title = seoMetaByLang[lang].title;
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) metaDesc.setAttribute('content', seoMetaByLang[lang].desc);
    const ogTitle = document.querySelector('meta[property="og:title"]');
    if (ogTitle) ogTitle.setAttribute('content', seoMetaByLang[lang].title);
    const ogDesc = document.querySelector('meta[property="og:description"]');
    if (ogDesc) ogDesc.setAttribute('content', seoMetaByLang[lang].desc);
    const twitterTitle = document.querySelector('meta[name="twitter:title"]');
    if (twitterTitle) twitterTitle.setAttribute('content', seoMetaByLang[lang].title);
    const twitterDesc = document.querySelector('meta[name="twitter:description"]');
    if (twitterDesc) twitterDesc.setAttribute('content', seoMetaByLang[lang].desc);
    const headerTag = document.querySelector('h1.sr-only');
    if (headerTag) headerTag.innerHTML = seoMetaByLang[lang].title;
  }

  // Update selected class in dropdown
  document.querySelectorAll('.lang-item').forEach(item => {
    if (item.getAttribute('data-lang') === lang) {
      item.classList.add('selected');
    } else {
      item.classList.remove('selected');
    }
  });

  // Update selected in mobile buttons
  document.querySelectorAll('.mobile-lang-btn').forEach(btn => {
    if (btn.getAttribute('data-lang') === lang) {
      btn.classList.add('selected');
    } else {
      btn.classList.remove('selected');
    }
  });

  // Close dropdown if open
  const menu = document.getElementById('langDropdownMenu');
  if (menu) menu.classList.remove('active');

  // Recalculate calculator to reflect language
  calculateBestCourier();
}

// Toggle Language Dropdown
function toggleLangDropdown(event) {
  if (event) event.stopPropagation();
  const menu = document.getElementById('langDropdownMenu');
  if (menu) menu.classList.toggle('active');
}

// Close language dropdown on outside click
window.addEventListener('click', (e) => {
  const menu = document.getElementById('langDropdownMenu');
  const wrapper = document.querySelector('.lang-selector-wrapper');
  if (menu && wrapper && !wrapper.contains(e.target)) {
    menu.classList.remove('active');
  }
});
